"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIssueTemplateDisplayValue = exports.IssueTemplatesDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SelectBoxWrapper = require("../../utils/components/SelectBoxWrapper");
var _hooks = require("../../state/redux/hooks");
var _issueTemplates = require("../../state/redux/ducks/issueTemplates");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _useRecentlyUsedTemplateIds = require("../../utils/hooks/useRecentlyUsedTemplateIds");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _featureFlags = require("../../utils/featureFlags");
var _DropdownUtils = require("../../utils/components/DropdownUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RECENTLY_USED_PREFIX = "RECENTLY-USED-";
const useIssueTemplateDisplayValue = issueTemplateId => {
  const getIssueTemplateById = (0, _hooks.useSelector)(_issueTemplates.getFnForGetIssueTemplateById);
  if (issueTemplateId) {
    const template = getIssueTemplateById(issueTemplateId);
    return template === null || template === void 0 ? void 0 : template.issueAttributes.title;
  }
};
exports.useIssueTemplateDisplayValue = useIssueTemplateDisplayValue;
const IssueTemplatesDropdown = _ref => {
  let {
    selectedIssueTemplateId,
    onChange
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase2Batch1);
  const issueTemplateDisplayValue = useIssueTemplateDisplayValue(selectedIssueTemplateId);
  const {
    recentlyUsedTemplatesToDisplay,
    addTemplateIdToRecentlyUsed
  } = (0, _useRecentlyUsedTemplateIds.useRecentlyUsedTemplateIds)({
    selectedTemplateId: selectedIssueTemplateId
  });
  const recentlyUsedTemplatesMemo = (0, _react.useMemo)(() => recentlyUsedTemplatesToDisplay, [recentlyUsedTemplatesToDisplay]);
  const generateRecentlyUsedTemplateObject = (0, _react.useCallback)(() => {
    const options = recentlyUsedTemplatesMemo.map(template => ({
      label: template.issueAttributes.title,
      // we need to give it a unique value so as not to mess up the picker
      value: RECENTLY_USED_PREFIX + template.id
    }));
    return {
      label: T.translate("templateSelector.recentlyUsed"),
      // TODO: remove when component migration is finalized
      options,
      // we just need any string here, to be used as the option key
      typeId: "recently-selected-templates",
      items: options
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  // if we just use the selector, we end up with a reference to the same list
  // in different renders and unshifting onto it messes things up.
  // So, we copy the list into a new reference
  const groupedOptions = [...(0, _hooks.useSelector)(_issueTemplates.getActiveTemplateOptionsGroupedByType)];

  // add the recently used section if there's no search
  if (recentlyUsedTemplatesMemo.length) {
    groupedOptions.unshift(generateRecentlyUsedTemplateObject());
  }
  const handleChange = (0, _react.useCallback)(item => {
    let value;
    if (item) {
      const {
        selectedItem
      } = item;
      value = selectedItem.value;
      if (value.startsWith(RECENTLY_USED_PREFIX)) {
        // get the template ID from the option value that includes the recently used prefix,
        // because we need unique values for options
        value = value.slice(RECENTLY_USED_PREFIX.length);
      }
      addTemplateIdToRecentlyUsed(value);
    }
    onChange && onChange(value);
  }, [onChange, addTemplateIdToRecentlyUsed]);
  const OldDropdown = () => /*#__PURE__*/_react.default.createElement(_SelectBoxWrapper.GroupedSelectBoxWrapper, {
    placeholder: T.translate("issueCreation.template.placeholder"),
    valueRenderer: () => issueTemplateDisplayValue,
    value:
    // selectedIssueTemplateId will always be part of the recently used list,
    // and that is the one we want selected
    selectedIssueTemplateId ? {
      value: RECENTLY_USED_PREFIX + selectedIssueTemplateId
    } : null,
    options: groupedOptions,
    onChange: option => {
      let value = undefined;
      if (option) {
        value = option.value;
        if (value.startsWith(RECENTLY_USED_PREFIX)) {
          // get the template ID from the option value that includes the recently used prefix,
          // because we need unique values for options
          value = value.slice(RECENTLY_USED_PREFIX.length);
        }
        addTemplateIdToRecentlyUsed(value);
      }
      onChange && onChange(value);
    },
    clearable: true,
    searchable: true,
    defaultInputValue: ""
  });
  const semanticIdentifier = "templates-dropdown";
  const NewDropdown = () => {
    const getSelectedItem = (0, _react.useCallback)(() => {
      if (!selectedIssueTemplateId) return;

      // new dropdown requires referential equality for the selected item
      for (const group of groupedOptions) {
        const selected = group.items.find(option => "RECENTLY-USED-".concat(selectedIssueTemplateId) === option.value || selectedIssueTemplateId === option.value);
        if (selected) {
          return selected;
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // TODO: remove when component migration is finalized
    groupedOptions.forEach(group => group.items = group.options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const selectedItem = (0, _react.useMemo)(getSelectedItem, [selectedIssueTemplateId]);
    const {
      menuProps,
      controlProps
    } = (0, _alloyReactDropdown.useAutocomplete)({
      groupedItems: groupedOptions,
      selectedItem,
      onSelectedItemChange: handleChange,
      id: semanticIdentifier
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.AutocompleteControl, _extends({}, controlProps, {
      placeholder: T.translate("issueCreation.template.placeholder"),
      "data-testid": "".concat(semanticIdentifier, "-control")
    })), /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.AutocompleteMenu, _extends({}, menuProps, {
      renderFooter: () => (0, _DropdownUtils.DropdownFooter)({
        isClearable: true,
        handleChange,
        shouldDisplay: !!selectedIssueTemplateId
      }),
      "data-testid": "".concat(semanticIdentifier, "-menu")
    }), menuProps.menuItems.map((itemOrGroupHeader, i) => (0, _alloyReactDropdown.isGroupHeader)(itemOrGroupHeader) ? /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MenuGroupHeader, {
      key: i,
      "data-testid": "".concat(semanticIdentifier, "-header-").concat(i)
    }, itemOrGroupHeader.label) : /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MenuItem, _extends({
      key: i
    }, menuProps.getItemProps({
      item: itemOrGroupHeader
    }))))));
  };
  return shouldUseNewDropdown ? NewDropdown() : OldDropdown();
};
exports.IssueTemplatesDropdown = IssueTemplatesDropdown;
//# sourceMappingURL=IssueTemplatesDropdown.js.map